import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';
import { TableDataJSON } from '../../../src/types/table-json';

export const varianceDescription: CalculatorDescription = {
  id: CalculatorId.VARIANCE,
  title: 'Variance calculator',
  metaTitle: 'Variance Calculator - Measure Data Dispersion',
  description: 'Calculate the variance of your dataset to measure how spread out the values are from the mean.',
  metaDescription: 'Free online variance calculator. Measure data dispersion with our easy-to-use statistical tool. Calculate population and sample variance.',
  howTo: {
    title: 'How to calculate variance',
    steps: [
      'Enter your numeric data directly into the data table or upload a CSV file',
      'Use the "Select Data Column" control to choose which column of data to analyze',
      'The calculator will automatically compute both population and sample variance',
      'View the mean value and other statistical measures',
      'Examine the visualization to understand the data distribution and spread'
    ],
    graphic: {
      description: 'Visual representation of variance calculation'
    }
  },
  examples: [
    {
      title: 'Analyzing rainfall variation',
      description: 'Measuring the variability of monthly rainfall',
      dataDescription: 'Monthly rainfall amounts (in inches) for a year',
      insights: [
        'The variance is 8.76, indicating moderate variability',
        'Higher variance indicates more inconsistent rainfall patterns',
        'Lower variance would suggest more consistent rainfall throughout the year',
        'Variance is in squared units (inches²) unlike standard deviation'
      ],
      data: TableDataJSON.from({
        columns: [
          { 
            id: 'rainfall',
            name: 'Rainfall (inches)', 
            values: ['2.1', '1.8', '3.2', '4.5', '5.2', '3.8', '1.2', '0.8', '2.5', '4.2', '6.7', '5.8'] 
          }
        ]
      })
    }
  ],
  relatedCalculators: [
    CalculatorId.STANDARD_DEVIATION,
    CalculatorId.MEAN,
    CalculatorId.RANGE
  ]
}; 